module.exports = __webpack_public_path__ + "b3a22db68aff1be533a311a6534800c5.png";